import {
  snapRound,
  SnapRoundingOptions,
  SnapRoundingOptionsDecimalPercent,
  SnapRoundingOptionsPercent,
} from '@calculations/round/decimal';
import { Decimal } from '@snap-types/types/decimal';

/**
 * Converts a percentage to a decimal.
 *
 * @remarks
 * Decimals do not maintain trailing zeroes. For example, converting 50% to a decimal
 * will result in 0.5, not 0.5000. To render a decimal with trailing zeroes, you can
 * use `toFixed` with the number of decimal places you want to display.
 */
export function percentToDecimal(
  percent: Decimal,
  roundingOptions: SnapRoundingOptions = SnapRoundingOptionsDecimalPercent,
): Decimal {
  return snapRound(percent.dividedBy(100), roundingOptions);
}

export function decimalToPercent(
  decimalPercent: Decimal,
  roundingOptions: SnapRoundingOptions = SnapRoundingOptionsPercent,
): Decimal {
  return snapRound(decimalPercent.times(100), roundingOptions);
}
